<template>
  <v-container fluid class="container-tcca-alert">
    <v-layout md1 pd1 mb-4>
      <v-card dark width="100%" class="card">
        <v-card-title>
          <v-flex style="font-size:26px;" class="text-xs-left">
            <span>Alert History</span>
          </v-flex>
        </v-card-title>
      </v-card>
    </v-layout>
    <!-- <v-spacer /> -->

    <!-- Dialog Alert  Details -->
    <div class="text-xs-center">
        <v-dialog
          v-model="isDialogAlertDetailShown"
          width="1024"
          persistent
        >
            <v-card class="grey darken-2">
                <v-card-title
                  class="headline grey darken-4"
                  style="color:#cccccc;"
                  primary-title
                >
                Alert Details
                <v-spacer />
                    <v-btn icon dark @click="isDialogAlertDetailShown = false" style="outline: none;">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="text-md-left">
                  <v-expansion-panel v-model="panel1">
                    <v-expansion-panel-content class="grey lighten-1">
                      <template v-slot:actions>
                        <v-icon >expand_more</v-icon>
                      </template>
                      <template v-slot:header>
                        <span>Setting</span>
                      </template>
                      <v-layout align-star justify-space-between mx-0 mb-0 style="padding:20px;" class="grey lighten-3">
                        <table class="table-detail" id="seedetail-panel1">
                          <tr>
                            <td>Alert Name:  <span>{{alertname}}</span></td>
                            <td>Alert Status:  <span>{{status}}</span></td>
                            <td>Device:  <span>{{alertdevice}}</span></td>
                            <td>Query By:  <span style="cursor: pointer; color: #0091EA !important; text-decoration-line: underline;"
                                @click="toSearch(query, '1')">
                                {{ query.toString().split('text: ')[1] }}
                                <span id="new">click !</span>
                              </span>
                            </td>
                            <td>Event type:  <span @click="toSearch">{{type}}</span></td>
                          </tr>
                          <tr>
                            <td>Field To Use Alert:
                              <span v-if="type == 'count'">{{field}}</span>
                              <span v-else>{{fieldalert}}</span>
                            </td>
                            <td>Alert Rule: <span>{{rule}}</span></td>
                            <td>Run Alert Every:  <span>{{time}}</span></td>
                            <td>Alert To:  <span>{{email}}</span></td>
                          </tr>
                        </table>
                      </v-layout>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel v-model="panel2" >
                    <v-expansion-panel-content class="grey lighten-1">
                      <template v-slot:actions>
                        <!-- <v-icon v-if="panel == null">add_circle_outline</v-icon>
                        <v-icon v-else>remove_circle_outline</v-icon> -->
                        <v-icon >expand_more</v-icon>
                      </template>
                      <template v-slot:header>
                        <div>Alert</div>
                      </template>
                      <v-card class="grey lighten-3" id="seedetail-panel2">
                        <v-card-text>แจ้งเตือนวันที่/เวลา: <span style="color: #26A69A;">{{datetime}}</span></v-card-text>
                        <v-card-text>ช่วงเวลา(Query log): <span style="color: #26A69A;">{{range}}</span></v-card-text>
                        <v-card-text>Alert Result:  <span style="color: #26A69A;">{{total}}</span></v-card-text>
                      </v-card>
                      <v-layout column justify-center mx-0>
                        <v-flex px-3 class="grey lighten-3">
                          <v-data-table
                              :headers="headerDetail"
                              :items="seedetail"
                              :pagination.sync="paginationdetail"
                              hide-actions>
                          <template slot="items" slot-scope="props">
                              <tr>
                                <td class="text-xs-center"><span style="cursor: pointer; color: #EF5350 !important; text-decoration-line: underline;" @click="toSearch(props.item.key, '2')">{{ props.item.key }}</span></td>
                                <td class="text-xs-center"><span style="color: #26A69A;">{{ props.item.doc_count }}</span></td>
                              </tr>
                          </template>
                          </v-data-table>
                          <span class="recommend">* Click result in column for search more ...</span>
                        </v-flex>
                      </v-layout>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>

    <!-- Dialog Confirm Delete alert -->
    <div class="text-xs-center">
        <v-dialog
          v-model="isDialogConfirmDeleteShown"
          width="500"
        >
        <v-card>
            <v-card-title
                class="headline grey darken-4"
                style="color: #cccccc;"
                primary-title
            >
                Confirm Delete Alert
            </v-card-title>

            <v-card-text class="text-md-left">
              <br>
              <p style="font-size: 16px;">Are you sure delete selected {{ selected.length }} {{selected.length === 1 ? 'item' : 'items'}} ?</p>
            </v-card-text>

            <v-card-actions>
            <v-spacer />
            <v-btn
                color="red"
                style="outline: none;"
                outline
                @click="isDialogConfirmDeleteShown = false"
            >
                No
            </v-btn>
            <v-btn
                class="text-light green darken-2"
                style="outline: none;"
                @click="deleteAlert"
            >
                Yes
            </v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
    </div>

    <!-- iLog TCCA Alert History Table -->
    <v-layout id="data-table-tcca">
        <v-flex lg12 md12>
            <v-card dark>
                <v-card-title id="search-bar">
                  <v-flex ml-0>
                    <v-flex class="tine_header">Date Filter</v-flex>
                    <v-flex row ml-0 style="flex-wrap: nowrap;">
                      <v-flex lg5 md5>
                        <VueCtkDateTimePicker
                          id="DateTimePickerST"
                          v-model="abStartTime"
                          color="#1B4A86"
                          label="Start Time"
                          format="YYYY-MM-DDTHH:mm:ss"
                          dark/>
                      </v-flex>
                      <v-flex lg1 md1 mt-2 style="color:#cccccc;">
                        <p>To</p>
                      </v-flex>
                      <v-flex lg5 md5>
                        <VueCtkDateTimePicker
                          id="DateTimePickerEND"
                          v-model="abEndTime"
                          color="#1B4A86"
                          label="End Time"
                          format="YYYY-MM-DDTHH:mm:ss"
                          dark/>
                      </v-flex>
                      <v-flex md1 lg1 ml-2 style="position: relative; text-align: left;">
                        <button
                          style="height: 42px;"
                          class="btn bg-success font-weight-bold text-white"
                          type="submit"
                          @click="showFilter">
                            Submit
                        </button>
                      </v-flex>
                  </v-flex>
                </v-flex>
                <v-spacer />
                <v-flex lg1 md1 style="top: 10px; position: relative; margin-right: 20px;">
                  <v-select
                    v-model="device"
                    :items="devices"
                    label="Device"
                  />
                </v-flex>
                <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    style="width: 30px"
                    single-line
                    hide-details />
                </v-card-title>
                <v-flex left md2 ml-3>
                  <v-btn
                    slot="activator"
                    color="red lighten-2"
                    :disabled="selected.length == 0"
                    style="text-transform: none !important; outline: none;"
                    dark
                    round
                    small
                    @click="isDialogConfirmDeleteShown = true"
                  >
                  <v-icon size="22">delete</v-icon>
                    Delete selected
                  </v-btn>
                </v-flex>
                <v-data-table
                    v-model="selected"
                    :headers="header"
                    :items="datatables"
                    :loading="loadTable"
                    :pagination.sync="pagination"
                    item-key="_id"
                    select-all
                    hide-actions
                >
                <v-progress-linear slot:progress color="blue" indeterminate></v-progress-linear>
                <template slot="items" slot-scope="props">
                    <tr>
                      <td>
                        <v-checkbox
                          v-model="props.selected"
                          primary
                          hide-details
                        ></v-checkbox>
                      </td>
                      <td class="text-xs-left">{{ props.item.datetime }}</td>
                      <td class="text-xs-left">{{ props.item.range }}</td>
                      <td class="text-xs-left">{{ props.item.name }}</td>
                      <td class="text-xs-left">{{ props.item.device }}</td>
                      <td class="justify-center layout px-0">
                        <v-icon small class="mr-2" @click="seeDetails(props.item)" id="table-seedetail">
                          visibility
                        </v-icon>
                      </td>
                    </tr>
                </template>
                <template v-slot:no-results>
                    <v-alert :value="true" color="error" icon="warning">
                    Your search for "{{ search }}" found no results.
                    </v-alert>
                </template>
                </v-data-table>
                <v-layout align-center justify-center row fill-height>
                  <div class="text-xs-center" style="margin-top: 15px; height: 60px;">
                    <v-pagination
                      v-model="page"
                      :length="allPages"
                      :total-visible="total_visible"
                    ></v-pagination>
                  </div>
                  <div class="text-xs-center"
                    style="position: absolute; display:flex; flex-direction: row; width: 130px; right: 30px;">
                    <span style="width: 100px; align-self: center; margin: 0 15px;">page</span>
                    <v-text-field
                      v-model="gotoPage"
                      class="gopage"
                      :append-outer-icon="'chevron_right'"
                      @click:append-outer="goto"
                      @keyup.enter="goto"
                    />
                  </div>
                </v-layout>
                <!-- <div class="text-xs-center" style="margin-top: 15px; height: 60px;">
                  <v-pagination
                    v-model="page"
                    :length="allPages"
                    :total-visible="10"
                  ></v-pagination>
                </div>
                <div class="text-xs-center" style="margin-top: 0px; height: 60px; width: 25px; background-color: red;">
                  <v-text-field
                    v-model="gotoPage"
                  />
                </div> -->
            </v-card>
        </v-flex>
    </v-layout>
    <v-snackbar
        v-model="snackbar"
        :bottom="false"
        :left="false"
        :multi-line="true"
        :right="false"
        :timeout="5000"
        :top="true"
        :vertical="false">
    {{ snackbartext }}
        <v-btn
            color="pink"
            flat
            style="outline: none;"
            @click="snackbar = false">
        Close
        </v-btn>
    </v-snackbar>
    <v-tour name="recommand-tour-al-tcca" :steps="steps" :options="stepOptions" :callbacks="stepCallbacks">
      <template slot-scope="tour">
        <transition name="fade"></transition>
          <v-step
            v-if="tour.steps[tour.currentStep]"
            :key="tour.currentStep"
            :step="tour.steps[tour.currentStep]"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :skip="tour.skip"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
            :highlight="tour.highlight"
            class="tour-body"
          >
            <template>
              <v-layout slot="header" class="tour-header">
                <img v-if="tour.currentStep == 0" src="../assets/img/login/logo-ilog-256.png" alt="ilog_logo" style="width: 21px; height: 21px; position: relative; top: 5px; left: 50px;">
                <v-icon v-if="tour.currentStep == 1" style="position: relative; left: 130px; color: #fff;">search</v-icon>
                <v-icon v-if="tour.currentStep == 2" style="position: relative; left: 60px; color: #fff;">visibility</v-icon>
                <v-icon v-if="tour.currentStep == 3" style="position: relative; left: 130px; color: #fff;">settings</v-icon>
                <v-icon v-if="tour.currentStep == 4" style="position: relative; left: 55px; color: #fff;">table_chart</v-icon>
                <v-icon v-if="tour.currentStep == 5" style="position: relative; left: 110px; color: #fff;">chat</v-icon>
                <v-flex class="headline font-weight-light" v-html="tour.steps[tour.currentStep].header.title"></v-flex>
              </v-layout>
              <v-layout slot="content" class="tour-content" column>
                <v-flex class="body-2 font-weight-light" my-2>( {{tour.currentStep + 1}} / {{tour.steps.length}} )</v-flex>
                <v-flex class=" body-2 font-weight-light" v-html="tour.steps[tour.currentStep].content" ></v-flex>
              </v-layout>
              <v-layout slot="actions" fill-height align-center justify-center row>
                <v-flex v-if="tour.currentStep == 0" mt-2>
                  <v-btn @click="tour.nextStep" class="tour-btn-start font-weight-regular" block>Start</v-btn>
                  <button @click="tour.skip" class="tour-btn-skip">Skip</button>
                </v-flex>
                <v-flex v-else-if="!tour.isLast" column mt-3>
                  <v-btn @click="tour.previousStep" class="tour-btn-back font-weight-regular" round>Back</v-btn>
                  <v-btn @click="tour.nextStep" class="tour-btn-next font-weight-regular" round>Next</v-btn><br>
                  <button @click="tour.skip" class="tour-btn-skip">Skip</button>
                </v-flex>
                <v-flex v-else>
                  <v-btn @click="tour.finish" class="tour-btn-finish" block>Finish</v-btn>
                </v-flex>
              </v-layout>
            </template>
          </v-step>
      </template>
    </v-tour>
  </v-container>
</template>

<script>
import axios from 'axios'
import jwtDecode from 'jwt-decode'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
export default {
    name: 'alertHistoryTCCA',
    components: {
      VueCtkDateTimePicker
    },
    data () {
       return {
        page: 1,
        perPage: 10,
        allPages: null,
        total_visible: 10,
        gotoPage: 1,
        shownDetail: false,
        shownAlert: false,
        snackbar: false,
        snackbartext: '',
        selected: [],
        // pmDetail: false,
        panel1: [],
        panel2: [],
        header: [
          {
            text: 'Date/Time',
            value: 'datetime',
            align: 'left',
            sortable: false
          },
          {
            text: 'Time period(Query log)',
            value: 'range',
            align: 'left',
            sortable: false
          },
          {
            text: 'Alert Name',
            value: 'name',
            align: 'left',
            sortable: false
          },
          {
            text: 'Device',
            value: 'device',
            align: 'left',
            sortable: false
          },
          {
            text: 'Details',
            value: 'details',
            align: 'center',
            sortable: false
          }
        ],
        datatables: [],
        device: 'All',
        devices: ['All'],
        search: '',
        abStartTime: '',
        abEndTime: '',
        startTime: '',
        endTime: '',
        showFilterData: false,
        filterMode: false,
        loadTable: false,
        pagination: {
          descending: true,
          rowsPerPage: 10,
          sortBy: 'time'
        },
        paginationdetail: {
          descending: false,
          rowsPerPage: 100,
          sortBy: 'key'
        },
        isDialogAlertDetailShown: false,
        isDialogConfirmDeleteShown: false,
        alertname: '',
        status: '',
        alertdevice: '',
        query: '',
        type: '',
        field: '',
        rule: '',
        time: '',
        email: '',
        total: '',
        datetime: '',
        range: '',
        fieldalert: '',
        seedetail: [],
        headerDetail: [],
        token: '',
        user_id: '',
        searchFromAlert: '',
        finishLoadAlert: false,
        ampid: '',
        recommend: false,
        stepOptions: {
          useKeyboardNavigation: true,
          highlight: true,
          labels: {
            buttonSkip: 'ข้าม',
            buttonPrevious: 'ย้อนกลับ',
            buttonNext: 'ต่อไป',
            buttonStop: 'สิ้นสุด'
          }
        },
        stepCallbacks: {
          onSkip: this.finishStepTour,
          onFinish: this.finishStepTour
        },
        steps: [
          {
            target: '#search-bar',
            header: {
              title: 'Get Started with iLog 2.6'
            },
            content: `<h5>พบกับฟีเจอร์ใหม่ Alert history</h5><span>หน้าแดชบอร์ดที่คุณสามารถดูรายละเอียดการแจ้งเตือนย้อนหลัง<br>ทั้งหมดที่คุณได้ตั้งค่าไว้</span>`,
            params: {
              highlight: false,
              enableScrolling: false
            },
            before: () => {
              this.datatables = [
                {
                  _id: '60a7774405511a50ec6764b',
                  datetime: 'Fri May 21 2021 17:30:00 GMT+0700 (เวลาอินโดจีน)',
                  device: 'fortigate',
                  name: 'ผู้ที่ใช้งาน sicial media ในเวลาทำงาน',
                  range: '21/05  08:30 น.   -  21/05  17:30 น.',
                  event: [
                    {
                      id: '60a7774405511a50ec6764d3',
                      total: '2',
                      alertbox: {
                        _id: '60a7771805511a50ec676624',
                        action: 'Email',
                        alertid: '6093bba99046a230f84dc5bp',
                        email: 'example@email.co.th',
                        eventTrigger: 'count',
                        fieldalet: '',
                        intervals: '*/1 * * * *',
                        name: 'ผู้ที่ใช้งาน sicial media ในเวลาทำงาน',
                        query: ['text: 10*'],
                        raw_interval: '1  m',
                        selectedIndex: 'fortigate',
                        targetField: 'username',
                        trigger: 'Greater than  1',
                        unit: ''
                      },
                      data: [
                        {
                          _id: '60a7774405511a50ec6766e1',
                          key: 'Username 1',
                          doc_count: '8'
                        },
                        {
                          _id: '60a7774405511a50ec6766e2',
                          key: 'Username 2',
                          doc_count: '7'
                        },
                        {
                          _id: '60a7774405511a50ec6766e3',
                          key: 'Username 3',
                          doc_count: '6'
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          },
          {
            target: '#search-bar',
            header: {
              title: 'เมนูค้นหา'
            },
            content: `<span>พร้อมเมนูฟิลเตอร์ข้อมูลให้ได้ตามที่คุณต้องการ <br> ทั้งวันที่, อุปกรณ์ หรือ keyword สำคัญตามที่คุณต้องการ</span>`,
            params: {
              highlight: true,
              enableScrolling: false
            }
          },
          {
            target: '#table-seedetail',
            header: {
              title: 'ปุ่มดูรายละเอียดเพิ่มเติม'
            },
            content: `<span>คุณสามารถกดดูรายละเอียดเพิ่มเติมได้ที่นี่</span>`,
            params: {
              placement: 'left',
              highlight: false,
              enableScrolling: false
            },
            before: () => {
              this.isDialogAlertDetailShown = false
              this.panel1 = null
              this.panel2 = null
            }
          },
          {
            target: '#seedetail-panel1',
            header: {
              title: 'การตั้งค่า'
            },
            content: `<span>แท็บนี่จะเป็นส่วนที่แสดงรายละเอียดการตั้งค่าการแจ้งเตือนของคุณ</span>`,
            params: {
              highlight: true,
              enableScrolling: false
            },
            before: () => {
              this.seeDetails(this.datatables[0])
              this.panel1 = 0
              // this.panel2 = 0
            }
          },
          {
            target: '#seedetail-panel2',
            header: {
              title: 'รายละเอียดผลการทำงาน'
            },
            content: `<span>แท็บนี่จะเป็นส่วนที่แสดงผลการทำงาน</span>`,
            params: {
              highlight: false,
              enableScrolling: false
            },
            before: () => {
              this.panel1 = null
              this.panel2 = 0
              this.isDialogAlertDetailShown = true
            }
          },
          {
            target: '#search-bar',
            header: {
              title: 'Support iLog'
            },
            content: `<span>หากคุณมีข้อสงสัยเพิ่มเติมสามารถคลิกที่ปุ่มเมนู Manual ที่แถบเมนู <br>หรือสามารถติดต่อหา Support iLog ได้ผ่านทุกช่องทาง</span>`,
            params: {
              highlight: false,
              enableScrolling: false
            },
            before: () => {
              this.isDialogAlertDetailShown = false
            }
          }
        ]
       }
    },
    async created () {
      this.token = sessionStorage.getItem('user-token')
      let decoded = jwtDecode(this.token)
      this.ampid = decoded.ampid
      this.searchFromAlert = JSON.parse(sessionStorage.getItem('iLog-search-alert'))
      this.role = decoded.role
      this.user_id = decoded._id
      await this.getIndex()

      if (this.searchFromAlert) {
        this.abStartTime = this.searchFromAlert.startdate
        this.abEndTime = this.searchFromAlert.enddate
        this.device = this.searchFromAlert.device
        sessionStorage.removeItem('iLog-search-alert')
      }
      if (this.role === 'user') {
        let response = await axios.post(apiUrl + '/api/status/recommend', {
          command: 'get'
        })
        this.recommend = response.data.alerttcca
      }
      this.getDataTable()
    },
    methods: {
      async getDataTable () {
        this.loadTable = true
        this.startTime = Date.parse(this.abStartTime)
        this.endTime = Date.parse(this.abEndTime)
        let response = await axios.post(apiUrl + '/api/query/reworkAlert', {
            command: 'tcca',
            index: this.devices,
            selected: this.device,
            start: this.startTime,
            end: this.endTime,
            search: this.search,
            page: this.page - 1,
            perPage: this.perPage
        })
        // console.log(response.data)
        if (response.data) {
          let page = Math.floor(response.data.pages / 10)
          page === 0 ? this.allPages = 1 : this.allPages = page + 1

          this.datatables = []
          response.data.table.map(el => {
              this.datatables.push({
                  datetime: el.datetime,
                  time: Date.parse(el.datetime),
                  device: el.device,
                  event: el.event,
                  name: el.name,
                  range: el.range,
                  _id: el._id
              })
          })

          this.loadTable = false
        } else {
          this.page = 1
          this.allPages = 1
          this.datatables = []
          this.loadTable = false
        }
      },
      showFilter () {
          // this.showFilterData = true
          this.page = 1
          this.getDataTable()
          window.analytics.track(`[AlertHistory][iLog][SubmitTime]`, {
          value: {
              start: this.abStartTime,
              end: this.abEndTime
          }
          }, {
          integrations: {
              Amplitude: {
              'session_id': this.ampid
              }
          }
          })
      },
      goto () {
        this.page = parseInt(this.gotoPage)
      },
      seeDetails (e) {
          window.analytics.track(`[ALertHistory][iLog][Detail]`, {}, {
            integrations: {
                Amplitude: {
                'session_id': this.ampid
                }
            }
          })
          // console.log(e)
          this.panel1 = null
          this.panel2 = null
          this.alertname = e.name
          this.status = 'DECTECED'
          this.alertdevice = e.device
          this.total = e.event[0].total
          this.datetime = e.datetime
          this.range = e.range
          this.query = e.event[0].alertbox.query
          this.type = e.event[0].alertbox.eventTrigger
          this.field = e.event[0].alertbox.targetField
          this.fieldalert = e.event[0].alertbox.fieldalet
          this.rule = e.event[0].alertbox.trigger
          this.time = e.event[0].alertbox.raw_interval
          this.email = e.event[0].alertbox.email
          this.seedetail = e.event[0].data
          if (this.type === 'count') {
          this.headerDetail = [
            {
              text: this.field + ' *',
              value: 'key',
              align: 'center',
              class: 'white--text body-2 grey darken-3',
              sortable: true
            },
            {
              text: 'Event Count',
              value: 'doc_count',
              align: 'center',
              class: 'white--text body-2 grey darken-3',
              sortable: true
            }
          ]
          } else {
            this.headerDetail = [
            {
                text: this.fieldalert + ' *',
                value: 'key',
                align: 'center',
                class: 'white--text body-2 grey darken-3',
                sortable: true
              },
              {
                text: 'Result',
                value: 'doc_count',
                align: 'center',
                class: 'white--text body-2 grey darken-3',
                sortable: true
              }
            ]
          }
          this.isDialogAlertDetailShown = true
          // this.shownDetail = true
      },
      async deleteAlert () {
          window.analytics.track(`[AlertHistory][iLog][Delete]`, {
            value: {
                alert: this.selected
            }
            }, {
            integrations: {
                Amplitude: {
                'session_id': this.ampid
                }
            }
          })
          this.loadTable = true
          this.isDialogConfirmDeleteShown = false
          let alertid = []
          if (this.selected.length > 0) {
          this.selected.map(item => {
              alertid.push(item._id)
          })
          }
          // console.log(alertid)
          let response = await axios.post(apiUrl + '/api/query/deleteAlertTcca', alertid)
          if (response.data.msg === 'success') {
            this.loadTable = false
            this.snackbartext = 'Delete selected alert success'
            this.snackbar = true
            this.selected = []
            this.getDataTable()
          } else {
            this.loadTable = false
            this.snackbartext = 'Please try again later'
            this.snackbar = true
            this.selected = []
            this.getDataTable()
          }
      },
      async getIndex (e) {
          let response = await axios.post(apiUrl + '/api/query/getAllIndex', {
          id: this.user_id,
            command: 'tcca'
          })
          response.data.map(el => this.devices.push(el))
      },
      toSearch (e, type) {
          window.analytics.track(`[Alert History][Detailes][Search]`, {
            value: {
              start: this.abStartTime,
              end: this.abEndTime,
              device: this.alertdevice,
              text: e
            }
            }, {
            integrations: {
                Amplitude: {
                  'session_id': this.ampid
                }
            }
          })
          let dataDateTime = new Date(this.datetime)
          let dateTimeST = this.range.split('-')[0].trim().split(/(\d\d)/)
          let dateTimeEND = this.range.split('-')[1].trim().split(/(\d\d)/)
          // let newDateST = new Date(dataDateTime.getFullYear(), dateTimeST[3] - 1, dateTimeST[1], dateTimeST[5], dateTimeST[7], 0)
          // let newDateEND = new Date(dataDateTime.getFullYear(), dateTimeEND[3] - 1, dateTimeEND[1], dateTimeEND[5], dateTimeEND[7], 0)
          let newDateST = `${dataDateTime.getFullYear()}-${dateTimeST[3]}-${dateTimeST[1]}T${dateTimeST[5]}:${dateTimeST[7]}:10`
          let newDateEND = `${dataDateTime.getFullYear()}-${dateTimeEND[3]}-${dateTimeEND[1]}T${dateTimeEND[5]}:${dateTimeEND[7]}:10`
          let textSearch
          if (type === '1') {
            textSearch = {text: e[0].split('text: ')[1], device: this.alertdevice, startdate: newDateST, enddate: newDateEND}
          } else if (type === '2') {
            textSearch = {text: e, device: this.alertdevice, startdate: newDateST, enddate: newDateEND}
          }
          // this.$router.replace({ name: 'dashboard', params: { isExpired: this.isExpired, querydata: textSearch } })
          // console.log(textSearch)
          sessionStorage.setItem('iLog-search', JSON.stringify(textSearch))
          let routeData = this.$router.resolve({name: 'dashboard'})
          window.open(routeData.href, '_blank')
          sessionStorage.removeItem('iLog-search')
      },
      async finishStepTour () {
          this.isDialogAlertDetailShown = false
          this.getDataTable()
          await axios.post(apiUrl + '/api/status/recommend', {
            command: 'disalerttcca'
          })
      }
    },
    watch: {
      recommend: function () {
          if (this.recommend && this.$router.history.current.name === 'alertHistorytcca') {
              setTimeout(() => {
                  this.$tours['recommand-tour-al-tcca'].start()
              }, 1000)
          }
      },
      abStartTime: async function () {
          window.analytics.track(`[AlertHistory][iLog][StartTime]`, {}, {
              integrations: {
                  Amplitude: {
                  'session_id': this.ampid
                  }
              }
          })
          if (!this.abStartTime) {
            this.page = 1
            this.getDataTable()
          }
      },
      abEndTime: async function () {
          window.analytics.track(`[AlertHistory][iLog][EndTime]`, {}, {
              integrations: {
                  Amplitude: {
                  'session_id': this.ampid
                  }
              }
          })
          if (!this.abEndTime) {
            this.page = 1
            this.getDataTable()
          }
      },
      panel1: function () {
          if (this.panel1 === 0) {
              window.analytics.track(`[AlertHistory][iLog][Detail][Setting]`, {}, {
                  integrations: {
                      Amplitude: {
                          'session_id': this.ampid
                      }
                  }
              })
          }
      },
      panel2: function () {
          if (this.panel2 === 0) {
              window.analytics.track(`[AlertHistory][iLog][Detail][Alert]`, {}, {
                  integrations: {
                      Amplitude: {
                          'session_id': this.ampid
                      }
                  }
              })
          }
      },
      page: function () {
        this.gotoPage = this.page
        this.getDataTable()
      },
      device: function () {
        this.page = 1
        this.getDataTable()
      },
      search: function () {
        window.analytics.track(`[AlertHistory][iLog][Search]`, {
            value: {
                keyword: this.search
            }
        }, {
            integrations: {
                Amplitude: {
                'session_id': this.ampid
                }
            }
        })
        this.page = 1
        this.getDataTable()
      }
    }
}
</script>

<style scoped>
.container-tcca-alert {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  margin-bottom: 60px;
}

.card {
  border-radius: 3px;
  color: #cccccc;
}

.tine_header {
  text-align: left;
  color: #cccccc;
}

.table-detail {
  width: 100%;
  text-align: left;
  border-collapse: initial;
}

.table-detail > tr {
  background-color: transparent !important;
  border: none;
}

.table-detail > tr > td > span{
  /* color: #00E676; */
  color: #26A69A;
  margin: 0 3px;
}

#new {
  color: #EF5350;
  position: absolute;
  top: 163px;
  transform:rotate(15deg);
  font-size: 0.8rem;
}

.recommend {
  margin: 8px 0;
  font-size: 12px;
  color: #EF5350;
}

.v-tour__target--highlighted {
  box-shadow: 0 0 0 99999px rgba(0,0,0,.8);
}

.tour-body {
  max-width: 900px !important;
  min-width: 450px !important;
  max-height: 300px !important;
  padding: 0 !important;
  margin: auto !important;
  background-color: #212121 !important;
}
.tour-btn-start {
  color: #fff !important;
  background-color: #009688 !important;
  box-shadow: none !important;
  border-radius: 13px !important;
  width: 260px !important;
  outline: none !important;
  margin: 0 auto !important;
  margin-top: 10px !important;
  text-transform: none !important;
  font-size: 16px !important;
}
.tour-btn-skip {
  position: relative !important;
  left: 190px !important;
  text-transform: none !important;
  outline: none !important;
  font-size: 13px !important;
  margin: 10px 0 !important;
  color: #616161 !important;
  text-decoration-line: underline !important;
  font-style: normal !important;
  font-weight: normal !important;
}
.tour-btn-back {
  margin:0 10px !important;
  color: #212121 !important;
  outline: none !important;
  background-color: #fff !important;
  text-transform: none !important;
  box-shadow: none !important;
  border-radius: 13px !important;
}
.tour-btn-next {
  margin:0 10px;
  color: #fff !important;
  outline: none !important;
  background-color: #009688  !important;
  text-transform: none !important;
  box-shadow: none !important;
  border-radius: 13px !important;
}
.tour-btn-finish {
  color: #fff !important;
  outline: none !important;
  background-color: #009688  !important;
  text-transform: none !important;
  box-shadow: none !important;
  border-radius: 13px !important;
  width: 25px !important;
  margin: 20px auto;
}
.tour-header {
  border-bottom: 1px solid #BDBDBD !important;
  margin: 12px 30px !important;
  padding: 0 !important;
}
.tour-content {
  font-size: 14px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/alertHistoryTCCA_new.vue